import "./src/styles/global.css";
import "@mantine/carousel/styles.css";
import "@mantine/core/styles.css";

import React from "react";
import { MantineProvider } from "@mantine/core";

export const wrapRootElement = ({ element }) => {
  return <MantineProvider>{element}</MantineProvider>;
};
